import { createContext, useContext } from "react";

export const SessionAutoStartContext = createContext(true);

export const useSessionAutoStartAllowed = () =>
	useContext(SessionAutoStartContext);
